import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

type FAQItem = {
  question: string;
  answer: string;
};

const faqItems: FAQItem[] = [
  {
    question: "O que é a PODKST.AI?",
    answer: "PODKST.AI é uma plataforma de criação de podcasts com Inteligência Artificial. Ela gera automaticamente roteiros completos e narrações realistas em português, com base em temas inseridos pelo usuário."
  },
  {
    question: "Como funciona a criação de podcasts com IA?",
    answer: "Você insere um tema, palavra-chave ou ideia. A IA analisa o contexto e gera um roteiro estruturado, com storytelling e fluidez. Em seguida, você escolhe uma das vozes disponíveis para narrar o conteúdo e exporta o episódio em áudio de alta qualidade."
  },
  {
    question: "Preciso ter experiência com edição de áudio?",
    answer: "Não! A PODKST.AI faz tudo para você: gera o roteiro, narra automaticamente com vozes profissionais em português e entrega o áudio pronto para baixar ou compartilhar."
  },
  {
    question: "Quais são as vozes disponíveis na plataforma?",
    answer: "Você pode escolher entre 12 vozes com Inteligência Artificial, todas em português, com diferentes tons, estilos e personalidades — vozes femininas e masculinas com qualidade de estúdio."
  },
  {
    question: "É possível criar cortes curtos para redes sociais como TikTok e Reels?",
    answer: "Sim! Mesmo gerando um episódio completo, você pode ajustar a duração e criar trechos impactantes para redes sociais como TikTok, Instagram Reels e YouTube Shorts. Ideal para viralizar conteúdo com rapidez."
  },
  {
    question: "Posso editar o roteiro antes de gravar o episódio?",
    answer: "Sim. Após a geração automática, você pode revisar, ajustar ou complementar o roteiro antes de gerar o áudio. A plataforma é flexível para garantir o seu estilo."
  },
  {
    question: "Em quais formatos posso exportar o episódio?",
    answer: "Os episódios podem ser exportados em .mp3 ou .wav, com alta qualidade de áudio, prontos para distribuição em qualquer plataforma de podcast ou redes sociais."
  },
  {
    question: "A PODKST.AI tem versão gratuita?",
    answer: "Sim. Você pode criar uma conta gratuitamente, testar a geração de episódios e experimentar as vozes antes de optar por planos com recursos avançados."
  },
  {
    question: "É seguro e confiável usar vozes geradas por IA?",
    answer: "Sim. Todas as vozes são licenciadas e otimizadas para uso comercial e pessoal. A PODKST.AI garante conformidade com padrões éticos e de privacidade de dados."
  },
  {
    question: "Quem pode se beneficiar da PODKST.AI?",
    answer: "Qualquer pessoa que queira criar conteúdo em áudio: influenciadores, marcas, agências, criadores independentes, especialistas, professores, coaches, profissionais de marketing, e muito mais. Não há barreiras técnicas."
  }
];

export function FAQAccordion() {
  return (
    <Accordion type="single" collapsible className="w-full max-w-4xl mx-auto">
      {faqItems.map((item, index) => (
        <AccordionItem 
          key={index} 
          value={`item-${index}`}
          className="border-b border-zinc-800 overflow-hidden"
        >
          <AccordionTrigger className="text-white hover:text-primary text-left py-5 text-lg font-medium">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="text-gray-400 pb-5">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
} 